module.exports = __webpack_public_path__ + "assets/valance-whale-tail-v2.bc140911.svg";